'use client';

import React from 'react';
import NameSearch from './NameSearch';
import HotJobTitles from './HotJobTitles';
import HotJobs from './HotJobs';
import HotCities from './HotCities';
import JobTitlesRank from './JobTitlesRank';
import { SeoHotDataType } from '@/types/common';

const LandingPage = (props: SeoHotDataType) => {
  const { hotJobTitles, hotCities, jobTitlesRank, hotJobs } = props;

  return (
    <>
      <NameSearch hotJobTitles={hotJobTitles} />
      <HotJobTitles hotJobTitles={hotJobTitles} />
      <HotCities hotCities={hotCities} />
      <JobTitlesRank jobTitlesRank={jobTitlesRank} />
      <HotJobs hotJobs={hotJobs} />
    </>
  );
};

export default LandingPage;
